import { z } from 'zod';
import { accountSchema } from './wizard/schemas/account.schema';

/** The Account tab edits what the wizard's first step collected, under the same rules. */
export const lenderAccountSchema = accountSchema
  .pick({ lenderName: true, salesforceId: true, nmlsId: true, street: true, city: true, state: true, zip: true })
  .extend({ primaryContact: z.string() });

export type LenderAccountValues = z.infer<typeof lenderAccountSchema>;
